import { Link } from "react-router-dom";
import Room from "@/components/Room";

export default function AdaptationIntelligence() {
  return (
    <Room title="Biological Limits" description="The biological limits adaptation plans run into, and why models miss them.">
      <div className="fade">
        <div className="kicker">Adaptation Intelligence</div>
        <h1 data-testid="adaptation-h1">Every adaptation plan assumes the biology can keep up.</h1>
        <div className="goldrule"></div>
        <p className="lede">Capital, infrastructure and policy adapt on a timetable. Bodies, soils, water and trees do not, and each carries a limit no budget moves. The limits arrive before the models that ought to price them.</p>
      </div>

      <section className="q">
        <div className="n">01</div>
        <h2>How hot can a human body keep working?</h2>
        <p>A body cools by evaporating sweat. When the air is hot and humid enough, sweat stops evaporating and the body can no longer shed heat, however fit or well watered the person is. The theoretical ceiling was set at a wet-bulb temperature of 35°C. Laboratory work on young, healthy people has since put the practical limit nearer 31°C.</p>
        <p>The harvest, the factory floor and the building site sit close to that line on more days each year. What does your labour assumption do on the days they cross it?</p>
        <p className="src">Sherwood and Huber, PNAS, 2010. Vecellio et al., Journal of Applied Physiology, 2022.</p>
      </section>

      <section className="q">
        <div className="n">02</div>
        <h2>How long does it take to replace topsoil?</h2>
        <p>Soil forms from rock and life at the pace of geology. The FAO puts it at up to a thousand years for a single centimetre. Topsoil stripped in one night of flooding is, on any human timescale, gone. Fertiliser can feed a crop. It cannot rebuild the structure that held the water.</p>
        <p className="src">Food and Agriculture Organization of the United Nations, Global Soil Partnership.</p>
      </section>

      <section className="q">
        <div className="n">03</div>
        <h2>Does an aquifer refill after a wet year?</h2>
        <p>Pumped hard for long enough, the fine sediments holding the water compact. Compacted ground holds less, so recharge refills a smaller container than the one that was emptied. The rain comes back, but the storage does not. A wet year after that point is read as recovery and priced as recovery, and it is neither.</p>
        <p className="src">US Geological Survey, land subsidence and aquifer-system compaction.</p>
      </section>

      <section className="q">
        <div className="n">04</div>
        <h2>Can a plantation grow out of reach?</h2>
        <p>An oil palm keeps growing upward long after its yield has peaked. Past about twenty metres it can no longer be harvested by hand, and the tree cannot be made shorter. When a whole planting cohort passes that height together, the constraint is the reach of a human arm, not the price of oil or the weather.</p>
      </section>

      <section className="q">
        <div className="n">05</div>
        <h2>What do the four share?</h2>
        <p>Each is physical, measurable and indifferent to price. Each arrives quietly: the worker still turns up, the field is still green, the well still pumps and the tree still stands. And each is missing from the models that decide where adaptation money goes.</p>
        <p>Where these limits sit decides which regions, crops and workforces hold their value through the next two decades and which do not. The ones that hold are not yet priced as holding. Adaptation intelligence states where the limits sit before capital is committed against them, rather than discovering them in the loss.</p>
      </section>

      <section className="close">
        <p className="ask">Your adaptation plan carries a date. The biology it depends on carries its own. Which arrives first, and which side of that gap do you want to own?</p>
        <Link className="write" to="/enter/biological-limits" data-testid="adaptation-write">Write</Link>
      </section>
    </Room>
  );
}
